import React, { useRef, useState, useEffect } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "@fontsource/norwester";
import Comlogo from "../../Assets/Comlogo.png";
import "./topbar.css";

const Topbar = ({ processRef, servicesRef, testsRef }) => {

    const navRef = useRef();
    const [menuOpen, setMenuOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const navigate = useNavigate();


    const showNavBar = () => {
        setMenuOpen(prev => !prev);
    }

    const smoothScrollTo = (element) => {
        if (!element) return;

        const targetPosition = element.getBoundingClientRect().top + window.scrollY;
        const startPosition = window.scrollY;
        const distance = targetPosition - startPosition;
        const duration = 800; // Increase this value for slower scrolling
        let startTime = null;

        const animation = (currentTime) => {
            if (!startTime) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);

            window.scrollTo(0, run);
            if (timeElapsed < duration) requestAnimationFrame(animation);
        };

        requestAnimationFrame(animation);
    };

    const easeInOutQuad = (t, b, c, d) => {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    // Modify your handlers like this
    const handleProcessClick = () => {
        // First navigate to home page if not already there
        if (window.location.pathname !== '/') {
            navigate('/');
            // Wait for navigation to complete before scrolling
            setTimeout(() => {
                smoothScrollTo(processRef?.current);
            }, 100);
        } else {
            // If already on home page, just scroll
            smoothScrollTo(processRef?.current);
        }
        setMenuOpen(false);
    };

    const handleServiceClick = () => {
        // First navigate to home page if not already there
        if (window.location.pathname !== '/') {
            navigate('/');
            // Wait for navigation to complete before scrolling
            setTimeout(() => {
                if (servicesRef?.current) {
                    servicesRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    });
                }
            }, 100);
        } else {
            // If already on home page, just scroll
            if (servicesRef?.current) {
                servicesRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest'
                });
            }
        }
        setMenuOpen(false);
    };

    const handleHome = () => {
        navigate("/");
        setMenuOpen(false);
    }

    const handleContact = () => {
        navigate("/contactUs");
        setMenuOpen(false);
    }

    const handlePrivacy = () => {
        navigate("/privacy");
        setMenuOpen(false);
    }

    const handleBlog=()=>{
        navigate("/Blog");
        setMenuOpen(false);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="topbar-container">
                <div className="topbar-left">
                    <div className="com-img">
                        <img className="logo" onClick={handleHome} src={Comlogo} alt="logo" />
                    </div>
                </div>
                <div className={`topbarCentre ${menuOpen ? "nav-active" : ""}`} ref={navRef}>
                    <span className="web-tags" onClick={handleHome}>Home</span>
                    <div className="dropdown"
                        onMouseEnter={() => setDropdownOpen(true)}
                        onMouseLeave={() => setDropdownOpen(false)}>
                        <span className="web-tags" onClick={handleServiceClick}>Our services</span>
                        {dropdownOpen && (
                            <div className="dropdown-menu">
                                <NavLink className="nav-servbtn" to="/serviceFB">Franchise Expansion</NavLink>
                                <NavLink className="nav-servbtn" to="/serviceDM">Digital Marketing</NavLink>
                                <NavLink className="nav-servbtn" to="/serviceWEB">Website Development</NavLink>
                                <NavLink className="nav-servbtn" to="/serviceOM">Offline Marketing</NavLink>
                                <NavLink className="nav-servbtn" to="/serviceSB">Strategy Building</NavLink>
                                <NavLink className="nav-servbtn" to="/serviceBC">Business Consultation</NavLink>
                            </div>
                        )}
                    </div>
                    <span className="web-tags-pro" onClick={handleProcessClick}>Our process</span>
                    <span className="web-tags-pro" onClick={handleBlog}>Blogs</span>
                    <span className="web-tags" onClick={handleContact} >Contact us</span>
                    <span className="web-tags" onClick={handlePrivacy} >Privacy & policy</span>
                    <button className="nav-btn nav-close-btn" onClick={showNavBar}>
                        <FaTimes className="cross" />
                    </button>
                </div>
                {!menuOpen && (
                    <button className="nav-btn ham-btn" onClick={showNavBar}>
                        <FaBars className="ham" />
                    </button>
                )}
            </div>
        </>
    )
}

export default Topbar;